import React from 'react';

function SummarySection({ children, ...rest }) {
  return (
    <section className="ai-search-summary" {...rest}>
      {children}
    </section>
  );
}

export default SummarySection;
